import FormGroup from "legacy/FormGroup"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class InsuranceForm extends React.Component {
  render() {
    return (
      <div className="row nested-row">
        <h3 className={this.props.headerClassName || "mt-0 text-xl"}>
          Insurance
        </h3>
        <div className="col-sm-4">
          <FormGroup
            autoFocus
            disabled={this.props.disabled}
            name="insurance.companyName"
            label="Company Name"
            labelClassName={this.props.labelClassName}
            placeholder={this.props.optional && "(Optional)"}
            value={
              (this.props.insurance && this.props.insurance.companyName) || ""
            }
            onChange={this.props.setParentState}
            validation={this.props.validator.message(
              "insurance_company",
              !this.props.optional &&
                this.props.insurance &&
                this.props.insurance.companyName,
              "required"
            )}
          />
        </div>
        <div className="col-xs-6 col-sm-4">
          <FormGroup
            disabled={this.props.disabled}
            name="insurance.policyNumber"
            label="Policy Number"
            labelClassName={this.props.labelClassName}
            placeholder={this.props.optional && "(Optional)"}
            value={
              (this.props.insurance && this.props.insurance.policyNumber) || ""
            }
            onChange={this.props.setParentState}
            validation={this.props.validator.message(
              "insurance_policy_number",
              !this.props.optional &&
                this.props.insurance &&
                this.props.insurance.policyNumber,
              "required"
            )}
          />
        </div>
        <div className="col-xs-6 col-sm-4">
          <FormGroup
            disabled={this.props.disabled}
            name="insurance.expirationDate"
            label="Expiration Date"
            labelClassName={this.props.labelClassName}
            placeholder={this.props.optional && "(Optional)"}
            value={
              (this.props.insurance && this.props.insurance.expirationDate) ||
              ""
            }
            inputType="datepicker"
            validation={this.props.validator.message(
              "insurance_expiration_date",
              !this.props.optional &&
                this.props.insurance &&
                this.props.insurance.expirationDate &&
                moment(this.props.insurance.expirationDate),
              ["required", { after_or_equal: moment() }]
            )}
            startDate={moment()}
            onChange={(expirationDate) =>
              this.props.setParentState({
                target: {
                  name: "insurance.expirationDate",
                  value: moment(expirationDate).format("YYYY-MM-DD"),
                },
              })
            }
          />
        </div>
      </div>
    )
  }
}

InsuranceForm.propTypes = {
  disabled: PropTypes.bool,
  headerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  optional: PropTypes.bool,
  insurance: PropTypes.shape({
    companyName: PropTypes.string,
    policyNumber: PropTypes.string,
    expirationDate: PropTypes.string,
  }),
  setParentState: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
}

InsuranceForm.defaultProps = {
  disabled: false,
  optional: false,
  insurance: {},
}

export default InsuranceForm
